import React, { useState, useEffect } from "react"
import { PaymentCard } from "../../api/models/OrderData"
import { Box, Typography, IconButton, Grid, Button } from "@material-ui/core"
import { Delete, CheckCircleOutline } from "@material-ui/icons"
import { red } from "@material-ui/core/colors"
import { useDispatch, useSelector } from "react-redux"
import { RootState } from "typesafe-actions"
import { QmoModal } from "../../Layout/components/QmoModal"
import { removePaymentCardDataAsyncThunk, getRestaurantPaymentCardsAsyncThunk } from "../accountDetailsSlice"
import QmoLoader from "../../Common/QmoLoader"

interface IProps {
    card: PaymentCard
}

export default function RestaurantPaymentCard({ card }: IProps) {
    const dispatch = useDispatch()
    const _accountDetails = useSelector((state: RootState) => state.accountDetailsRdc)
    const [removeCardOpen, setRemoveCardOpen] = useState(false)

    return (
        <>
            <Box style={{ border: "solid 1px", borderRadius: '10px', position: 'relative' }} p={2}>
                <IconButton onClick={() => setRemoveCardOpen(true)} style={{ color: red[600], position: 'absolute', top: 0, right: 0 }} ><Delete /> </IconButton>
                <Typography variant="h3">{card.country}&nbsp;{card.brand.toUpperCase()}</Typography>
                <Typography></Typography>
                <Box p={2}><Typography variant="h3">**** **** **** {card.dynamicLast4}</Typography></Box>
                <Typography variant="h4">EXP. {card.expMonth}/{card.expYear}</Typography>
            </Box>

            {removeCardOpen &&
                <QmoModal
                    title="Remove payment source"
                    open={removeCardOpen}
                    customContent={
                        <>
                            {_accountDetails.removePaymentCardDataBusy ?
                                <QmoLoader />
                                :
                                <div>
                                    {_accountDetails.removePaymentCardDataSuccess === true ?
                                        <Grid container spacing={4} style={{ textAlign: "center" }}>
                                            <Grid item xs={12} sm={12}>
                                                <CheckCircleOutline style={{ color: 'green', fontSize: "7.5em" }} />
                                                <Typography variant="h2">Success!</Typography>
                                                <Typography variant="h4">Card data removed successfuly!</Typography>
                                            </Grid>
                                            <Grid item xs={12} style={{ textAlign: 'center' }}>
                                                <Button onClick={() => { dispatch(getRestaurantPaymentCardsAsyncThunk()); setRemoveCardOpen(false) }} variant="outlined" color="primary">Close</Button>
                                            </Grid>
                                        </Grid>
                                        :
                                        <>
                                            {_accountDetails.removePaymentCardDataSuccess === false ?
                                                <Box p={1} textAlign="center">
                                                    <Typography color="error">Something went wrong. Try again later.</Typography>
                                                    <Button onClick={() => setRemoveCardOpen(false)} variant="outlined" color="primary">Close</Button>
                                                </Box>

                                                :
                                                <>
                                                    <Box p={1} textAlign="center"><Typography>Are you sure you want to delete below payment card<br /><b>**** {card.dynamicLast4}</b> ?</Typography></Box>
                                                    <Grid container>
                                                        <Grid item xs={6} sm={6} style={{ textAlign: 'center' }}>
                                                            <Button color="primary" variant="outlined" onClick={() => {
                                                                setRemoveCardOpen(false)
                                                            }}>No</Button>
                                                        </Grid>
                                                        <Grid item xs={6} sm={6} style={{ textAlign: 'center' }}>
                                                            <Button color="primary" variant="contained" onClick={() => {
                                                                dispatch(removePaymentCardDataAsyncThunk(card.id))
                                                            }}>Yes</Button>
                                                        </Grid>
                                                    </Grid>
                                                </>
                                            }

                                        </>
                                    }
                                </div>
                            }
                        </>

                    }
                >

                </QmoModal>
            }
        </>
    )
}